<!-- Template con estilos del dashboard -->
<div class="app-page">
  <div class="app-page-content">
    <section class="app-card">

      <!-- Header -->
      <header class="mb-6 flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
        <div class="flex flex-col gap-1">
          <h1 class="section-title">Rubros</h1>
          <p class="section-subtitle">
            Gestión de rubros del sistema
          </p>
        </div>

        <div class="flex flex-wrap items-center gap-2">
          <span class="app-badge">
            <strong>{{ totalRecords() }}</strong> rubros
          </span>
          <span
            class="app-badge"
            [ngClass]="{
              'app-badge-primary': !paginate
            }">
            {{ paginate ? 'Paginado' : 'Todos' }}
          </span>
        </div>
      </header>

    <p-confirmDialog [baseZIndex]="10000"></p-confirmDialog>

    <p-table
      #dt
      [value]="rubros()"
      [columns]="columnsTable"
      dataKey="id"
      sortMode="multiple"
      [(selection)]="selectedRows"
      [loading]="loading()"
      [rowHover]="true"
      [lazy]="true"
      (onLazyLoad)="loadLazy($event)"
      styleClass="app-table-container"
      [paginator]="paginate"
      [rows]="nroFilasPorPagina"
      [totalRecords]="totalRecords()"
      [filterDelay]="500"
      [scrollable]="false"
      [globalFilterFields]="['codigo','nombre','descripcion']"
      currentPageReportTemplate="{first} - {last} de {totalRecords} registros"
      [showCurrentPageReport]="true"
      [rowsPerPageOptions]="rowsPerPageOptions"
      responsiveLayout="stack"
      [breakpoint]="'960px'">

      <!-- Toolbar Caption -->
      <ng-template pTemplate="caption">
        <div class="flex flex-col gap-4 py-2">
          <div class="flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
            <!-- Search Input -->
            <div class="w-full md:max-w-96">
              <span class="p-input-icon-left w-full search-input-wrapper">
                <i class="pi pi-search search-icon"></i>
                <input
                  type="text"
                  pInputText
                  [(ngModel)]="filterValue"
                  (input)="dt.filterGlobal(filterValue, 'contains')"
                  placeholder="Buscar por código, nombre o descripción"
                  class="w-full"
                />
              </span>
            </div>

            <!-- Action Buttons -->
            <div class="flex flex-wrap items-center gap-2.5">
              <button
                pButton
                type="button"
                [label]="paginate ? 'Paginado' : 'Todos'"
                [icon]="paginate ? 'pi pi-lock' : 'pi pi-lock-open'"
                class="p-button-outlined p-button-sm"
                (click)="paginate = !paginate; cargar()">
              </button>
              <button
                pButton
                type="button"
                label="Limpiar"
                icon="pi pi-filter-slash"
                class="p-button-outlined p-button-sm"
                (click)="clear(dt)">
              </button>
              <button
                pButton
                type="button"
                label="Nuevo Rubro"
                icon="pi pi-plus"
                class="p-button-sm"
                (click)="navigateToCreateRubro()">
              </button>
            </div>
          </div>
        </div>
      </ng-template>

      <!-- Column Headers -->
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th *ngFor="let col of columns"
              [pSortableColumn]="col.sortable ? col.field : ''"
              class="px-4 py-3.5 text-left text-xs font-semibold uppercase tracking-wide">
            <div class="flex items-center justify-between gap-2">
              <span>{{ col.header }}</span>
              <div class="flex items-center gap-2">
                <p-sortIcon *ngIf="col.sortable" [field]="col.field"></p-sortIcon>
                <p-columnFilter
                  *ngIf="col.filtrable"
                  [type]="getFilterType(col)"
                  [field]="col.field"
                  [display]="col.modeDisplayFilter || 'menu'"
                  [showMatchModes]="false"
                  [matchMode]="getMatchMode(col.fieldType)"
                  [showOperator]="false"
                  [showAddButton]="false">
                </p-columnFilter>
              </div>
            </div>
          </th>
        </tr>
      </ng-template>

      <!-- Table Body -->
      <ng-template pTemplate="body" let-rubro let-columns="columns">
        <tr class="transition-colors">
          <td *ngFor="let col of columns" [ngSwitch]="col.field" class="px-4 py-4">
            <!-- Campo Código -->
            <div *ngSwitchCase="'codigo'">
              <span class="text-sm font-medium" style="color: hsl(var(--text));">
                {{ rubro.codigo || '-' }}
              </span>
            </div>

            <!-- Campo Nombre -->
            <div *ngSwitchCase="'nombre'">
              <span class="text-sm font-medium" style="color: hsl(var(--text));">
                {{ rubro.nombre || '-' }}
              </span>
            </div>

            <!-- Campo Descripción -->
            <div *ngSwitchCase="'descripcion'">
              <span class="text-sm text-muted">
                {{ rubro.descripcion || '-' }}
              </span>
            </div>

            <!-- Campo Activo -->
            <div *ngSwitchCase="'active'" class="flex items-center gap-2">
              <i
                [class]="rubro.active ? 'pi pi-check-circle' : 'pi pi-times-circle'"
                [style.color]="rubro.active ? 'hsl(var(--success))' : 'hsl(var(--danger))'"
                class="text-lg">
              </i>
            </div>

            <!-- Campo Acción -->
            <div *ngSwitchCase="'accion'" class="flex items-center gap-2">
              <button
                pButton
                type="button"
                icon="pi pi-pencil"
                class="p-button-rounded p-button-text p-button-sm"
                pTooltip="Editar"
                tooltipPosition="top"
                (click)="editarRubro(rubro.id!)">
              </button>
              <button
                *ngIf="rubro.active"
                pButton
                type="button"
                icon="pi pi-trash"
                class="p-button-rounded p-button-text p-button-sm p-button-danger"
                pTooltip="Desactivar rubro"
                tooltipPosition="top"
                (click)="eliminarRubro(rubro)">
              </button>
              <button
                *ngIf="!rubro.active"
                pButton
                type="button"
                icon="pi pi-check"
                class="p-button-rounded p-button-text p-button-sm p-button-success"
                pTooltip="Activar rubro"
                tooltipPosition="top"
                (click)="activarRubro(rubro)">
              </button>
            </div>

            <!-- Campos por defecto (texto) -->
            <div *ngSwitchDefault>
              <span class="text-sm text-muted">
                {{ rubro[col.field] || '-' }}
              </span>
            </div>
          </td>
        </tr>
      </ng-template>

      <!-- Empty Message -->
      <ng-template pTemplate="emptymessage">
        <tr>
          <td [attr.colspan]="columnsTable.length" class="text-center py-8">
            <div class="flex flex-col items-center gap-3">
              <i class="pi pi-inbox text-5xl text-muted"></i>
              <p class="text-muted">No se encontraron rubros</p>
            </div>
          </td>
        </tr>
      </ng-template>

      <!-- Loading Template -->
      <ng-template pTemplate="loadingbody">
        <tr>
          <td [attr.colspan]="columnsTable.length">
            <div class="flex items-center justify-center py-8">
              <i class="pi pi-spin pi-spinner text-3xl" style="color: hsl(var(--primary));"></i>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
    </section>
  </div>
</div>
